import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/_work/shadow/shadow/packages/line-activation-liff/layouts/default.vue").then(m => m.default || m))
}